import { z } from '../zod.js';

export const SnapshotBillingConfigSchema = z.object({
  interval: z.string().nullish(),
  intervalCount: z.number().nullish(),
  trialPeriodDays: z.number().nullish(),
  billingCycleAnchorConfig: z
    .object({
      enabled: z.boolean().nullish(),
      dayOfMonth: z.number().nullish(),
      month: z.number().nullish(),
    })
    .nullish(),
  startDate: z.iso.datetime().nullish(),
});

/**
 * Frozen snapshot of the purchased price captured at point of purchase (see
 * buildPriceSnapshot). All fields are optional — charges omit the billing
 * configs, subscriptions omit the PWYW fields, and legacy records have no
 * snapshot at all.
 */
export const PriceSnapshotSchema = z
  .object({
    priceId: z.string().nullish(),
    label: z.string().nullish(),
    description: z.string().nullish(),
    badge: z.string().nullish(),
    reference: z.string().nullish(),
    billingType: z.string().nullish(),
    amount: z.number().nullish(),
    currency: z.string().nullish(),
    discountedFromPrice: z.number().nullish(),
    setupFee: z.number().nullish(),
    setupFeeMultipliesWithQuantity: z.boolean().nullish(),
    stripePriceId: z.string().nullish(),
    stripePriceLivemode: z.boolean().nullish(),
    managedInStripe: z.boolean().nullish(),
    payWhatYouWant: z.boolean().nullish(),
    pwywSuggestedPrice: z.number().nullish(),
    recurring: SnapshotBillingConfigSchema.nullish().openapi({
      description:
        'Recurring billing config the customer purchased on. Never present together with paymentPlan.',
    }),
    paymentPlan: SnapshotBillingConfigSchema.extend({ planIterations: z.number().nullish() })
      .nullish()
      .openapi({
        description:
          'Payment plan config the customer purchased on — recurring billing that completes after planIterations cycles. Never present together with recurring.',
      }),
  })
  .openapi('PriceSnapshot', {
    description: 'Frozen snapshot of the purchased price at the point of purchase.',
  });
